import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useState} from 'react';
import {INPUT_TYPE} from "@app/constants/Common";

const RefereeConfirmModal = (props) => {
    const [confirmInput, setConfirmInput] = useState({
        refereeId: "",
        inputType: INPUT_TYPE.INPUT_PART,
        jobReferred: "",
        commentAboutPerson: ""
    })

    const {isShow, refererId, jobId, isFromPipeline, onClose, onNext} = props

    confirmInput.refererId = refererId
    confirmInput.jobReferred = jobId
    const onChangeInputType = (event) => {
        confirmInput[event.target.name] = event.target.value
        setConfirmInput({...confirmInput})
    }
    const onOpenInputPerson = (event) => {
        if (confirmInput.inputType === INPUT_TYPE.UPLOAD_CV) {
            window.location.href = `/candidate/cv/upload?refererInfo=${encodeURIComponent(JSON.stringify(confirmInput))}`
        } else {
            window.location.href = `/person/create?refererInfo=${encodeURIComponent(JSON.stringify(confirmInput))}`
        }
        onClose()
    }

    const onBtnNextClick = () => {
        if (isFromPipeline && onNext) {
            onNext(confirmInput)
        } else {
            onOpenInputPerson()
        }
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Xác nhận nhập referee</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}>Referee ID: {refererId}</label>
                        </div>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}>Chọn phương thức nhập</label>
                            <select className='form-control'
                                    name={'inputType'}
                                    value={confirmInput.inputType}
                                    onChange={event => onChangeInputType(event)}>
                                <option value={'1'} key={`input-select-1`}>{"Upload CV"}</option>
                                <option value={'2'} key={`input-select-2`}>{"Nhập mẩu thông tin"}</option>
                            </select>
                        </div>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}><b>Job Refered</b></label>
                            <input type='text' className='form-control'
                                   value={confirmInput.jobReferred}
                                   name={'jobReferred'}
                                   onChange={event => onChangeInputType(event)} />
                        </div>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}><b>Comment về Person</b></label>
                            <input type='text' className='form-control'
                                   value={confirmInput.commentAboutPerson}
                                   name={'commentAboutPerson'}
                                   onChange={event => onChangeInputType(event)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            onClick={() => onBtnNextClick()}
                            >
                        <i className='fas fa-save mr-2'/>
                        Next
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RefereeConfirmModal;
